import { FC } from 'react';

/**
 * Estimatix brand logo (mark + "ESTIMATIX" wordmark) for the navbar.
 *
 * Rendered from the actualized vector brand assets. Two theme variants are shipped:
 * the light asset carries a dark-grey wordmark (crisp on light headers), the dark asset
 * carries a white wordmark (crisp on dark headers). They swap via `dark:` visibility so
 * the wordmark stays legible in both themes.
 */
export const Logo: FC<{ className?: string }> = ({ className }) => (
  <>
    <img src="/estimatix-logo.svg" alt="Estimatix" className={`block dark:hidden ${className ?? ''}`} />
    <img src="/estimatix-logo-dark.svg" alt="Estimatix" className={`hidden dark:block ${className ?? ''}`} />
  </>
);
